import React from "react";
import { Box, Tab, Tabs } from "@mui/material";

const tabStyle = {
  textTransform: "none",
  fontSize: { xs: "11px", sm: "12px", md: "16px" },
  fontFamily: "Inter",
  minWidth: { xs: "70px", sm: "100px", md: "120px" },
  padding: { xs: "6px 8px", sm: "12px 16px" },
  "&:hover": {
    color: (theme) => theme.palette.primary.light,
    opacity: 1,
  },
  "&.Mui-selected": {
    color: (theme) => theme.palette.primary.main,
    fontWeight: "700",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "#d1eaff",
  },
};

const SettingsTabNav = ({ currentTab, handleChange }) => (
  <Box>
    <Tabs
      value={currentTab}
      onChange={handleChange}
      indicatorColor="secondary"
      textColor="inherit"
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={{
        marginBottom: 2,
        "& .MuiTabs-indicator": {
          backgroundColor: (theme) => theme.palette.primary.main,
          height: 3,
        },
        "& .MuiTabs-scrollButtons": {
          display: { xs: "flex", md: "none" },
        },
        "& .MuiTabs-flexContainer": {
          justifyContent: { xs: "flex-start", md: "flex-start" },
        },
      }}
    >
      <Tab 
        component={"span"} 
        label="Establishment Details" 
        sx={tabStyle} 
      />
      <Tab 
        component={"span"} 
        label="Unit Sizes" 
        sx={tabStyle} 
      />
      <Tab 
        component={"span"} 
        label="Cost Analysis" 
        sx={tabStyle} 
      />
      <Tab 
        component={"span"} 
        label="User Preferences" 
        sx={tabStyle} 
      />
    </Tabs>
  </Box>
);

export default SettingsTabNav;
